import { render, staticRenderFns } from "./regx-add.vue?vue&type=template&id=12245560&"
import script from "./regx-add.vue?vue&type=script&lang=js&"
export * from "./regx-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports